import {useNavigation} from '@react-navigation/native';
import {StackNavigationProp} from '@react-navigation/stack';
import React, {useEffect, useMemo, useState} from 'react';
import {View} from 'react-native';
import {connect} from 'react-redux';
import {ApiResponse} from '../../../data/types/interface/api';
import {
  IData,
  IDataWs,
  IDisplay,
} from '../../../data/types/interface/demandeSimulation';
import {StackParams} from '../../../data/types/navigation';
import mapDispatchToProps from '../../../services/redux/mapDispatchToProps';
import mapStateToProps from '../../../services/redux/mapStateToProps';
import {Loader} from '../../components/Loader';
import {ProduitItem} from '../../components/ProduitItem';
import { HeaderScreen } from '../../components/Header/HeaderScreen';

type NavigationProps = StackNavigationProp<StackParams, 'DemanderSimulation'>;

interface Props {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getCategorieTypeassurance: any;
}

export function DemanderSimulationScreen(props: Props) {
  const {navigate} = useNavigation<NavigationProps>();
  const {getCategorieTypeassurance} = props;
  const [listItem, setListItem] = useState<Array<IDataWs>>();
  const [IsLoading, setIsLoading] = useState(true);

  useEffect(() => {
    getCategorieTypeassurance({}, (res: ApiResponse) => {
      setIsLoading(false);
      setListItem(
        res && res.data && res.data.items.length > 0
          ? res.data.items
          : undefined,
      );
    });
  }, [getCategorieTypeassurance]);

  const aList: IData[] = useMemo(
    (): IData[] => [
      {
        libelle: 'Famille',
        navigate: () => {
          navigate('DemanderSimulationFamille');
        },
        destinationPage: 'DemanderSimulationFamille',
        id: '',
        data: '',
        headerTitle: 'Demander simulation',
      },
      {
        libelle: 'Epargne et prévoyance',
        navigate: () => {
          navigate('Cotisation');
        },
        destinationPage: 'Cotisation',
        id: '',
        data: '',
        headerTitle: 'Demander simulation',
      },
    ],
    [],
  );

  const datas = listItem
    ? aList.map((elt, i) => {
        elt.libelle = listItem[i].nom;
        elt.id = listItem[i].id;
        elt.imageUrl = listItem[i].imageUrl;
        elt.action = listItem[i].action;
        return elt;
      })
    : [];

  const display: IDisplay = {items: []};
  display.items = datas;

  return (
    <View style={{flex: 1, backgroundColor: 'rgba(242,242,242,1)'}}>
      <HeaderScreen
        title="Demander simulation"
        type="home"
        noBreadcrumb={false}
      />
      {IsLoading ? (
        <Loader />
      ) : (
        <View>
          <ProduitItem data={display} />
        </View>
      )}
    </View>
  );
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const DemanderSimulation: any = connect(
  mapStateToProps,
  mapDispatchToProps,
)(DemanderSimulationScreen);
